import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ContactPhoneNumberInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Teléfono">
      {getFieldDecorator("contactPhoneNumber", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el teléfono."
          }
        ],
        initialValue: implementerProfile?.contactPhoneNumber
      })(
        <Input
          disabled={isBusy}
          id="contactPhoneNumber"
          name="contactPhoneNumber"
          placeholder="Teléfono"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
